import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { computeHealthyUnhealthyComparison } from "../utils/timelineComparison";
import { formatValue, formatTimelinePeriod } from "../utils/timelineFormatters";

const HealthyUnhealthyComparison = ({ t, dataPoints }) => {
  const comparison = useMemo(
    () => computeHealthyUnhealthyComparison(dataPoints),
    [dataPoints]
  );

  return (
    <div className="anomaly-chart-card">
      <div className="chart-card-header">
        <h6>{t("MetricAnomalyTimeline.comparison.label")}</h6>
      </div>
      <div className="chart-card-body">
        <div className="row g-3">
          <div className="col-md-6">
            <div className="mat-comparison-col mat-comparison-healthy">
              <h6>{t("MetricAnomalyTimeline.healthyPeriods.label")}</h6>
              <ul className="mat-comparison-list">
                <li>
                  {t("MetricAnomalyTimeline.cleanPeriodCount.label")}: {comparison.healthy.count}
                </li>
                <li>
                  {t("MetricAnomalyTimeline.averageValue.label")}: {formatValue(comparison.healthy.averageValue)}
                </li>
                <li>
                  {t("MetricAnomalyTimeline.longestCleanStreak.label")}: {comparison.healthy.longestCleanStreak}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mat-comparison-col mat-comparison-unhealthy">
              <h6>{t("MetricAnomalyTimeline.unhealthyPeriods.label")}</h6>
              <ul className="mat-comparison-list">
                <li>
                  {t("MetricAnomalyTimeline.unhealthyCount.label")}: {comparison.unhealthy.count}
                </li>
                <li>
                  {t("MetricAnomalyTimeline.averageValue.label")}: {formatValue(comparison.unhealthy.averageValue)}
                </li>
                <li>
                  {t("MetricAnomalyTimeline.highestDeviation.label")}:{" "}
                  {comparison.unhealthy.highestDeviation != null
                    ? `${comparison.unhealthy.highestDeviation.toFixed(1)}%`
                    : "—"}
                  {comparison.unhealthy.highestDeviationPeriod && (
                    <small className="d-block text-muted">
                      ({formatTimelinePeriod(comparison.unhealthy.highestDeviationPeriod)})
                    </small>
                  )}
                </li>
                <li>
                  {t("MetricAnomalyTimeline.maxAnomalyCount.label")}: {comparison.unhealthy.maxAnomalyCount}
                  {comparison.unhealthy.maxAnomalyCountPeriod && (
                    <small className="d-block text-muted">
                      ({formatTimelinePeriod(comparison.unhealthy.maxAnomalyCountPeriod)})
                    </small>
                  )}
                </li>
                <li>
                  {t("MetricAnomalyTimeline.mostSeverePeriod.label")}:{" "}
                  {comparison.unhealthy.mostSeverePeriod
                    ? formatTimelinePeriod(comparison.unhealthy.mostSeverePeriod)
                    : "—"}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(HealthyUnhealthyComparison);
